__turbopack_context__.v({
  "brands": "brands-component-module-scss-module__HGiVtq__brands",
  "brands__images": "brands-component-module-scss-module__HGiVtq__brands__images",
  "brands__images__picture": "brands-component-module-scss-module__HGiVtq__brands__images__picture",
  "brands__imagesa": "brands-component-module-scss-module__HGiVtq__brands__imagesa",
  "brands__placeholder-entry": "brands-component-module-scss-module__HGiVtq__brands__placeholder-entry",
  "brands__placeholder-logo": "brands-component-module-scss-module__HGiVtq__brands__placeholder-logo",
});
